import { render, staticRenderFns } from "./studyplan-apply.vue?vue&type=template&id=71f461d0&scoped=true"
import script from "./studyplan-apply.vue?vue&type=script&lang=js"
export * from "./studyplan-apply.vue?vue&type=script&lang=js"
import style0 from "./studyplan-apply.vue?vue&type=style&index=0&id=71f461d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f461d0",
  null
  
)

export default component.exports